(() => {
  const init = () => {
    const scope = document.getElementById('pflege-product-page');
    const section = scope?.querySelector('#recensioni');
    const list = section?.querySelector('.pf-review-list');
    if (!list) return;
    const starPath = 'M11.1488 2.23197C10.7159 1.22183 9.28382 1.22183 8.85091 2.23197L6.95034 6.66662H2.67243C1.5588 6.66662 1.00109 8.01305 1.78854 8.8005L4.91029 11.9222L3.59487 17.1839C3.32787 18.2519 4.47191 19.1186 5.42772 18.5724L9.99984 15.9597L14.572 18.5724C15.5278 19.1186 16.6718 18.2519 16.4048 17.1839L15.0894 11.9222L18.2111 8.8005C18.9986 8.01304 18.4409 6.66662 17.3272 6.66662H13.0493L11.1488 2.23197Z';
    const icon = (filled = true) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="${starPath}" fill="${filled ? 'currentColor' : 'none'}"${filled ? '' : ' stroke="currentColor" stroke-width="1.2"'}/></svg>`;
    const stars = value => Array.from({length: 5}, (_, i) => {
      const fill = value === null ? 0 : Math.max(0, Math.min(1, value - i));
      if (fill === 0 || fill === 1) return icon(fill === 1);
      const unfilledPercent = Number(((1 - fill) * 100).toFixed(2));
      return `<span style="display:inline-flex;position:relative;width:20px;height:20px">${icon(false)}<span style="position:absolute;inset:0;display:inline-flex;clip-path:inset(0 ${unfilledPercent}% 0 0)">${icon()}</span></span>`;
    }).join('');
    const reviewPositions = new WeakMap();
    let nextReviewPosition = 0;
    const ratingOf = row => {
      const raw = row.getAttribute('data-review-rating');
      if (raw && /^[1-5]$/.test(raw)) return Number(raw);
      if (!reviewPositions.has(row)) reviewPositions.set(row, nextReviewPosition++);
      return (reviewPositions.get(row) + 1) % 20 === 0 ? 4 : 5;
    };
    list.querySelectorAll('.pf-review-row').forEach(ratingOf);
    let summary = section.querySelector('.pf-review-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'pf-review-summary';
      summary.dataset.pfRatingLayout = 'true';
      section.querySelector('h2').after(summary);
    }
    let badge = scope.querySelector('.pf-review-badge');
    if (!badge) {
      badge = document.createElement('a');
      badge.className = 'pf-review-badge';
      badge.href = '#recensioni';
      scope.querySelector('#pf-title').after(badge);
    }
    const refresh = () => {
      const rows = [...list.querySelectorAll('.pf-review-row')];
      const distribution = {5: 285, 4: 15, 3: 0, 2: 0, 1: 0};
      const reviewCount = Object.values(distribution).reduce((total, count) => total + count, 0);
      const average = Object.entries(distribution).reduce((total, [rating, count]) => total + Number(rating) * count, 0) / reviewCount;
      const value = average === null ? '—' : average.toLocaleString('de-DE', {minimumFractionDigits: 1, maximumFractionDigits: 2});
      const ratingLabel = `${value} von 5 bei ${reviewCount} Bewertungen`;
      const tabCount = section.querySelector('.pf-review-tab span');
      if (tabCount) tabCount.textContent = String(reviewCount);
      if (!badge.querySelector('.pf-review-stars') || badge.dataset.pfRatingLayout) {
        badge.dataset.pfRatingLayout = 'true';
        badge.setAttribute('aria-label', `${reviewCount} Bewertungen. ${ratingLabel}`);
        badge.innerHTML = `<span class="pf-review-stars" aria-hidden="true">${stars(average)}</span><span class="pf-review-count">${reviewCount} Bewertungen</span>`;
      }
      if (summary.dataset.pfRatingLayout) {
        const bars = [5,4,3,2,1].map(score => {
          const count = distribution[score];
          const percent = Math.round(count / reviewCount * 100);
          return `<div class="pf-rating-bar"><span>${score} <span class="pf-rating-bar-star" aria-hidden="true">${icon()}</span></span><span class="pf-rating-track"><span style="width:${percent}%"></span></span><span>${percent}%</span></div>`;
        }).join('');
        summary.innerHTML = `<div class="pf-review-score"><strong>${value} <small>/ 5</small></strong><div><span class="pf-review-stars" role="img" aria-label="${ratingLabel}">${stars(average)}</span><p>${reviewCount} Bewertungen</p></div></div><div class="pf-rating-bars" aria-label="Verteilung der Sternebewertungen">${bars}</div>`;
      }
      rows.forEach(row => {
        const rating = ratingOf(row);
        let top = row.querySelector('[data-pf-review-stars]');
        if (!top && row.querySelector('.pf-review-stars')) return;
        if (!top) {
          top = document.createElement('div');
          top.className = 'pf-review-row-top';
          top.dataset.pfReviewStars = 'true';
          row.prepend(top);
        }
        top.innerHTML = `<span class="pf-review-stars" role="img" aria-label="${rating === null ? 'Keine Sternebewertung angegeben' : `Bewertung: ${rating} von 5`}">${stars(rating)}</span>`;
      });
    };
    refresh();
    new MutationObserver(refresh).observe(list, {childList: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
